"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Session {
    constructor({ authenticationToken, refreshToken }) {
        this.authenticationToken = authenticationToken;
        this.refreshToken = refreshToken;
    }
}
Session.fromJSON = (json) => {
    const { authenticationToken, refreshToken } = Object.assign({}, json);
    if (typeof authenticationToken !== 'string')
        throw new Error('.authenticationToken must be a string');
    if (typeof refreshToken !== 'string')
        throw new Error('.refreshToken must be a string');
    return new Session({
        authenticationToken,
        refreshToken,
    });
};
exports.default = Session;
